import dotenv from "dotenv";
dotenv.config();

let environment = {};
environment.qdm_admin_url = process.env.REACT_APP_QDM_ADMIN_ENDPOINT;

export default environment;
